import React from 'react';
import MisActivos from "../bienes/misActivos";

export default function Page(props) {

	return (
		<MisActivos />
	);
}